/** UPnP GetTransportInfo XML helpers shared by playUri failure verify paths. */

export function parseTransportStateFromXml(raw: string): string {
  const match = String(raw || '').match(/<CurrentTransportState>([\s\S]*?)<\/CurrentTransportState>/i);
  if (match?.[1]) return match[1].trim().toUpperCase();
  const upper = String(raw || '').toUpperCase();
  if (upper.includes('PLAYING')) return 'PLAYING';
  if (upper.includes('TRANSITIONING')) return 'TRANSITIONING';
  if (upper.includes('PAUSED_PLAYBACK')) return 'PAUSED_PLAYBACK';
  if (upper.includes('NO_MEDIA_PRESENT')) return 'NO_MEDIA_PRESENT';
  if (upper.includes('STOPPED')) return 'STOPPED';
  return 'UNKNOWN';
}

export function parseTrackUriFromXml(raw: string): string | null {
  const text = String(raw || '');
  const track = text.match(/<TrackURI>([\s\S]*?)<\/TrackURI>/i);
  if (track?.[1]?.trim()) return decodeXml(track[1].trim());
  const current = text.match(/<CurrentURI>([\s\S]*?)<\/CurrentURI>/i);
  if (current?.[1]?.trim()) return decodeXml(current[1].trim());
  return null;
}

export function parseDidlTitleFromXml(raw: string): string | null {
  const match = String(raw || '').match(/<dc:title>([\s\S]*?)<\/dc:title>/i);
  return match?.[1]?.trim() ? decodeXml(match[1].trim()) : null;
}

function decodeXml(value: string): string {
  return value
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'");
}
